import { UiSchema } from '@rjsf/utils';
import { Project, Secret } from 'api/model';
import { getProjectsOptions } from 'api/workflows-steps/formSchema';
import ListSelectionWidget from 'components/form/ListSelectionWidget';
import SecretValueWidget from 'components/form/SecretValueWidget';
import { JSONSchema7 } from 'json-schema';

function getFormSchema(projects?: Project[], projectId?: string): JSONSchema7 {
  const projectsOptions = getProjectsOptions(projects);

  return {
    type: 'object',
    properties: {
      name: {
        title: 'Name',
        type: 'string',
      },
      description: {
        title: 'Description',
        type: 'string',
      },
      type: {
        title: 'Type',
        type: 'string',
        anyOf: [
          { const: 'api_key', title: 'API Key' },
          { const: 'git_auth', title: 'Git Auth' },
          { const: 'coding_agent_credentials', title: 'Coding Agent Credentials' },
        ],
      },
      project_id: {
        title: 'Project',
        type: ['string', 'null'],
        description: 'The project this secret belongs to. If not set, the secret will be global.',
        default: projectId ?? null,
        anyOf: [{ const: null }, ...projectsOptions],
      },
      value: {
        title: 'Value',
        type: 'string',
      },
    },
    required: ['name', 'type', 'value'],
  };
}

function getUiSchema(isCreate: boolean, secret?: Secret): UiSchema {
  return {
    project_id: {
      'ui:widget': ListSelectionWidget,
      'ui:options': {
        autocomplete: true,
      },
    },
    value: isCreate
      ? {
          'ui:widget': 'password',
          'ui:placeholder': 'Enter the secret value here',
        }
      : {
          'ui:widget': SecretValueWidget,
          'ui:options': {
            disabled: true,
            secret,
          },
        },
  };
}

export { getFormSchema, getUiSchema };
